import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh_CN = {
    header: {
        user: '账号',
        password: '密码',
        forget: '忘记密码',
        login: '登录',
        register: '注册',
        verification: '验证码',
        RememberMe:'记住密码',
        Deposit:'存款',
        ScanLogin:'手机登录',
        APPDownload:'APP 下载',
        ClickApp:'点击下载应用',
        MemberCenter:'会员中心',
        mainAccount: '主要账户',
        mineAccount: '我的账户',
        inEmail: '站内信',
        loginOut: '退出登录',
        Betting: '投注记录',
        withdraw: '线上取款',
        deposit: '线上存款',
        transaction: '交易记录',
        checkUsername: '请输入账号',
        checkPassword: '请输入密码',
        checkVrifyCode: '请输入验证码',
        refresh:'账户金额刷新成功',
        seeMore:'查看更多',
        hotDiscount:'热门优惠',
        customer:'在线客服',
        downloadUrl:'下载APP',
        Eventhall:'活动大厅',
        Mobilebetting:'手机投注',
        Mobilebettin2:'扫描下载手机APP',
        Mobilebettin3:'防劫持 防跳转',
        Home:'首页',
        News:'公告',
        Confirm:'确认',
        exitSuccessfully:'退出成功',
    },
    notify:{
        success:'成功',
        warning:'警告',
        error:'错误',
    },
    login:{
        userPlace: '6–12位字母、数字或组合',
        passwordPlace: '6–12位字母、数字或组合',
        userRules1:'会员账号不能为空',
        userRules2:'6–12位字母、数字或组合',
        passwordRules:'会员密码不能为空',
        verificationRules:'验证码不能为空',
        finishContent:'请完成内容填写'
    },
    register: {
        FreeRegistration:'免费注册',
        ConfirmPassword:'确认密码',
        ConfirmPasswordPlace:'请再次确认密码',
        open: '开通用户',
        user: '会员账号:',
        userPlace: '6–12位字母、数字或组合',
        password: '会员密码:',
        passwordPlace: '6–12位字母、数字或组合',
        phone: '手机号:',
        phonePlace: '请输入手机号',
        phoneRules:'手机号不能少于',
        phoneTips: '手机号码是验证信息的重要途经，请正确填写。',
        agent: '代理代码',
        agentPlace: '请输入代理代码没有可不填',
        verification: '验证码:',
        verificationPlace: '请输入验证码',
        rule: '我已年满18岁，且已阅读并接收条款细则和隐私权政策',
        btn: '提交注册',
        agree:'我同意',
        epeatPassword1:'确认密码不能为空',
        epeatPassword2:'两次密码输入不一致',
        phoneNumber1:'手机号不能为空',
        phoneNumber2:'请输入正确的手机号',
        Returnsignin:'立即登录',
        Terms:'「GOAWin条款及细则」',
        pleaseRead:'请阅读隐私政策',
        realName:'真实姓名',
        realNamePlace:'请输入真实姓名(非必填)',
        realNamePlace_:'请输入真实姓名',
        realNameRules:'真实姓名不能为空',
        realNameRules2:'真实姓名不能少于',
        qq:'QQ',
        qqPlace:'请输入QQ号码(非必填)',
        qqPlace_:'请输入QQ号码',
        qqRules:'qq不能为空',
        qqRules2:'QQ不能少于',
        wx:'微信',
        wxPlace:'请输入微信号(非必填)',
        wxPlace_:'请输入微信号',
        realwxRules:'微信不能为空',
        realwxRules2:'微信不能少于',
        email:'电子邮箱',
        emailPlace:'请输入电子邮箱(非必填)',
        emailPlace_:'请输入电子邮箱',
        emailRulse:'电子邮箱不能为空',
        emailRulse2:'电子邮箱不能少于',
        emailRulse3:'请输入正确的邮箱格式',
        withdrawPassword:'取款密码',
        withdrawPasswordPlace:'请输入取款密码(非必填)',
        withdrawPasswordPlace_:'请输入取款密码',
        withdrawPasswordRules:'提款密码不能为空',
        withdrawPasswordRules2:'提款密码不能少于',
        allRules:'位或多于',
        Bit:'位'
    },
    agency:{
        title: '代理合作',
        affiliateAgree: '联营协议',
        agencyLogin: '代理登录',
        agencyRegister: '代理注册'
    },
    nav:{
        APPDownload:'APP Download',
        home:'首页',
        live: '真人游戏',
        sport:'体育竞技',
        slot: '电子游艺',
        discounts: '优惠活动',
        agency:'代理中心',
        ColorLight:'彩票',
    },
    newHome:{
        betnow:'立即投注',
        login:'请先登录',
        play:'立即游戏',
        sport:'Sports',
        slot:'电子游艺',
        live:'真人游戏',
    },
    walletlialog:{
        WALLET:'钱包',
        Deposit:'存款',
        Withdraw:'取款',
        WalletDetails:'钱包详情',
        MainAccount:'主账户',
        Cancel:'关闭',
        NoDate:'暂无游戏账户数据!',
        refreshsuccess:'账户金额刷新成功'
    },
    discounts:{
        Promotions:'优惠活动',
        details:'查看详情',
        noDiscounts: '暂无相关优惠!',
        discountsReceived: '领取红利',
        checkPlatform:'请选择平台',
        checkMoney: '请输入金额',
        checkMoneyPlace:'请输入存入游戏平台的金额',
        cancel: '取 消',
        confrim:'确 认',
        checkBisnum:'请输入投注单号',
        checkBisnum2:'请输入存入投注单号',
        needLoin:'登陆后才能领取红利',
        needLoin2:'登陆后才能领取红利',
        querylevel:'查询等级',
        queryresult:'查询结果',
        account:'会员账号',
        currentlevel:'当前等级',
        Totalcumulativebets:'累计总投注额',
        Accumulatedpromotionbonus:'累计晋级彩金', 
        Accumulatedsalary:'累计月俸禄',
        AccumulatedMonthlysalary:'累计周俸禄',
        Totalbetamountrequiredforpromotion:'距离晋级需总投注金额',
        loading:'拼命加载中',
        tips: '温馨提示',
    },
    forget:{
        RetrieveSMS:'短信找回',
        MailboxRetrieve: '邮箱找回',
        CustomerRetrieve:'客服找回',
        sendMsg:'发送验证码',
        checking: '验证',
        finish: '完成',
        userPlace:'请输入您的游戏账号',
        phonePlace:'请输入绑定的手机号',
        emailPlace:'请输入绑定的邮箱号',
        sendPhoneMsg:'发送手机验证码',
        sendEmailCode: '请输入绑定的邮箱号',
        sendEmail:'发送邮箱验证码',
        bindPhone:'请输入绑定的手机号',
        bindEmail:'请输入绑定的邮箱号',
        verifyPlace:'请输入验证码',
        tips:'我们已向你手机发送一条验证码，请注意查收',
        tips2:'我们已向你邮箱发送一条验证码，请注意查收',
        newPasswordPlace:'请输入新密码',
        reNewPasswordPlace: '请再次输入新密码',
        check:'验证',
        resetSuccess:'密码重置成功！',
        celebrate:'恭喜你！',
        determine:'确定',
        CustomerService: '联系客服',
        sendAgain:'再次发送验证码',
        // second: '秒后重新发送'
    },
    mine: {
        welcome: '欢迎您',
        balance: '余额',
        minecenter: '个人中心',
        AccountManagement:'账号管理',
        amountManage: '资金管理',
        Betting: '投注记录',
        welfare: '福利领取',
        transaction: '交易明细',
        myDiscount: '我的优惠',
        safe: '账户安全',
        inEmail: '站内信',
        loginOut: '退出',
        friend:'邀请朋友',
        informationCenter:'信息中心',
        MerchRecord: {
            ActivityReward: 'Activity Reward',
            More: 'More',
            Pending: 'Pending',
            Successed: 'Succeeded',
            Expired: 'Expired',
            Canceled: 'Canceled',
            Processing: 'Processing',
            reject: 'reject',
            Succeeded: 'Succeeded',
            Failed: 'Failed',
            Totaldeposit: 'Total deposit',
            Totalwithdrawal: 'Total withdrawal',
            TotalPromotion: 'Total Promotion'
        },
        center: {
            account: '账户',
            username: '用户名',
            balance: '账户余额',
            money: '泰铢',
            name: '姓名',
            authentication: '去认证',
            phone: '手机',
            email: '邮箱',
            draw: '去填写',
            wechat: '微信',
            tips: '温馨提示',
            congratulations: '恭喜你',
            success: '成功',
            qqConfirm: 'QQ号认证',
            qqrule: '请输入正确的QQ号',
            qqPlace: '请输入您的QQ号',
            wechatConfirm: '微信号认证',
            wechatrule: '请输入您的微信号',
            wechatPlace: '请输入您的微信号',
            cancel: '取 消',
            confrim: '认 证'
        },
        capital: {
            account: '账户明细',
            deposit: '存款',
            withdrawal: '取款',
            bankList: '银行卡管理',
            withdrawalList: '提现申请',
            lockAmount: '锁定明细',
            accountin: {
                balance: '账户资金',
                refresh: '刷新',
                accountBalance: '总账户',
                deposit: '存款',
                withdrawal: '取款',
                takeBack: '一键取回',
                AvailBalance: '可提资金',
                mainBalance: '主账户',
                money: '泰铢',
                RMB: 'RMB',
                describe: '暂无游戏账户数据 ！',
                describe2: '暂无游戏！',
                refreshSuccess: '账户金额刷新成功',
                takeBacking: '正在取回',
                takeBackError: '一键取回失败',
                gameBalance:'游戏账户金额',
            },
            depositin: {
                deposit: '存款',
                nocheck:'暂无支付方式！',
                limit: '存款限额：',
                limit2: '单笔限额：',
                money: 'INR',
                Previous:'上一步',
                Recharge:'立即存款',
                returns:'返回',
                Recharge1:'推荐充值金额',
                Recharge2:'您要充值',
                Recharge3:'充值金额',
                Recharge4:'请输入充值金额',
                choseBank: '请选择第三方支付银行',
                bank:{
                    title1:'1，填写转帐表格',
                    title2:'1，完成',
                    title3:'为了加快流程，请确保在提交之前完成存款',
                    copy:'复制',
                    Bank:'银行名称',
                    Beneficiary:'收款人',
                    Account:'帐户',
                    Cancel:'取消',
                    Next:'下一步',
                    successTitle1:'取消您的存款请求已发送',
                    successTitle2:'银行内转账：存款金额将在30分钟内反映在您的余额中。银行间转账：银行不承诺汇款到达时间。 如果您的资金在24小时内没有显示，请联系在线客服',
                    orderNumber:'订单号',
                    DepositorName:'存款人姓名',
                    Amount:'金额',
                    done:'完成',
                    dialogTitle:'请确认转账信息',
                    UP:'上传存款证明',
                    Confirmed:'已确认',
                    copysuccess:'复制成功',
                    pleaseAmount:'请输入入款金额',
                    pleaseName:'请输入存款人姓名',
                    pleaseImgUrl:'请上传支付凭证',
                    subsuccess:'提交成功',
                    suberr:'提交失败'
                },
                nobank:{
                    PayGate:'收款账号',
                    FEE:'手续费',
                    CollectionAccount:'收款二维码',
                    copy:'复制',
                    Cancel:'取消',
                    complete:'确认转账',
                    orderNumber:'订单号',
                    Submmit:'时间',
                    Amount:'金额',
                    Transfer:'Transfer',
                    title1:'仅适用于此交易，请再次检查下一笔交易',
                    title2:'您的存款请求已发送',
                },
                checkform:{
                    Depositlimit:'Deposit limit',
                    Amount:'金额',
                    DepositorName:'存款人姓名',
                    UP:'上传存款证明',
                    UPtips:'图像大小建议：1 MB支持格式：JPG，PNG，GIF，BMP',
                    chenkAmount1:'请输入正整数',
                    chenkAmount2:'存款金额不能少于',
                    chenkAmount3:'存款金额不能多于',
                    UPmessage:'上传成功',
                    err1:'上传图片格式不对!',
                    err2:'上传凭证大小不能超过 1MB!',
                },
                // check: '选择账户充值支付方式',
                // amountTips: '存款金额（泰铢）',
                // pleaseCheck: '请选择存款金额',
                // pleaseInput: '请输入存款金额',
                // next: '下一步',
                // tips1: '温馨提示',
                // tips2: '如果充值失败，请尝试更换支付通道或其他支付方式',
                // tips3: '如果弄遇到任何问题，请联系我们的',
                // customer: '在线客服',
                // CCB: '建设银行',
                // ABC: '农业银行',
                // ICBC: '工商银行',
                // BOC: '中国银行',
                // CEB: '光大银行',
                // PSBC: '邮政储蓄银行',
                // CITIC: '中信银行',
                // BCCB: '北京银行',
                // BOS: '上海银行',
                // CMBC: '民生银行',
                // choseTd: '请选择支付通道',
                // choseType: '请选择支付方式',
                // choseBank: '请选择第三方支付银行',
                // limit: '存款限额：',
                // money: 'INR',
                // steady: '稳定',
                // td: '通道',
                // limit2: '单笔限额：',
                // UnionPayGateway:'银联网关',
                // BankRemittance:'银行汇款'
            },
            withdrawalin: {
                title: '提款金额',
                amountPlace: '输入提款金额',
                refresh: '刷新可提余额',
                AvailBalance: '可提余额：',
                amount: '金额',
                tips: '提现金额在{min}以上才可提款,请勿输入小数',
                // tips: '(提现金额在',
                // tips3: '以上才可提款,请勿输入小数)',
                withdrawPassword:'取款密码',
                choseBankCard: '请选择提款银行卡',
                Please:'请选择',
                loading: '拼命加载中',
                addBankCard: '添加银行卡',
                tips2: '温馨提示: 提款需设置提款密码和认证手机号',
                next: '下一步',
                diatitle: '请输入提款密码',
                diaPlace: '请输入提款密码',
                confrim: '确 定',
                confrim1Title: '未设置提款密码, 是否去设置?',
                confrim2Title: '提款需要先完成手机认证, 是否去认证?',
                confrimTips: '温馨提示',
                confirmText: '确定',
                cancelText: '取消',
                wpandmb:'添加银行卡需要先完成手机认证和提款密码, 是否去认证?',
                choseBank: '请选择银行',
                choseAmount: '提现金额在',
                choseAmount2: '以上才可提款',
                noBalance: '可提余额不足',
                noPoint: '请勿输入小数',
                nopassword: '请输入提款密码',
                withdrawalSuccess: '提款申请成功，等待审核',
                refreshSuccess: '刷新成功'
            },
            bankListin: {
                title1: '查看银行卡',
                title2: '添加银行卡',
                loading: '拼命加载中',
                tips1: '温馨提示：删除银行卡请联系客服',
                addBankCard: '添加银行卡',
                bankUser: '持卡人',
                littleTips: '温馨提示',
                nameOnce: '持卡人姓名只能设置一次,并且需要与实名认证一致,后续修改请联系客服',
                namePlace: '请输入持卡人姓名',
                bankNum: '银行卡号',
                bankTips: '请输入正确的银行卡号，否则可能会显示异常',
                bankPlace: '请输入银行卡号',
                bankName: '银行名称',
                PbankName: '请选择银行名称',
                bankNamePlace: '请输入银行名称',
                subbranch: 'IFSC CODE',
                subbranchPlace: '请输入开户支行',
                Mobile:'银行预留手机号',
                Mobiletitle:'必须是在银行注册的联系电话',
                password: '提款密码',
                passwordPlace: '请输入提款密码',
                add: '添加',
                confirmTitle: '绑定银行卡需要设置提款密码, 是否去设置?',
                confirmTips: '温馨提示',
                confirmText: '确定',
                cancelText: '取消',
                Cancel:'取消',
                OK:'确认',
                cantBank: '现在无法绑定银行卡',
                addSuccess: '添加成功',
                Required:'不能为空',
                bkNbrules:'必须6-22位数字',
            },
            withdrawalListlis: {
                loading: '拼命加载中',
                search: '搜索',
                time: '申请时间',
                amount: '申请金额',
                status: '申请状态',
                bankName: '提现银行',
                bankNumber: '提现卡号',
                remark: '备注',
                statusAll: '全部',
                applying: '申请中',
                payment: '出款中',
                success: '成功',
                reject: '拒绝'
            },
            lockAmountin: {
                rechargeLock: '充值锁定',
                allStates: '全部状态',
                lockIn: '锁定中',
                Unlocked: '已解锁',
                Cancelled: '已取消',
                order: '序号',
                principal: '充值本金',
                lockInAmount: '锁定金额',
                targetFlow: '目标流水',
                flowComple: '流水完成',
                lockStatus: '锁定状态',
                handle: '操作',
                deblocking: '解锁',
                discountsLock: '优惠锁定',
                allPlatform: '全部平台',
                mainAccount: '主账户',
                bonusName: '红利名称',
                bonusType: '红利类型',
                platform: '平台',
                bonusLockStatus: '红利状态',
                deblockingSuccess: '解锁成功'
            }
        },
        betlist: {
            allPlatform: '全部平台',
            bizNo: '投注单号',
            platformCode: '平台编号',
            gameType: '游戏类型',
            betAmount: '下注金额',
            betAmount2: '下注金额:',
            betflow: '有效投注',
            betflow2: '有效投注:',
            resultAmount: '玩家盈利',
            resultAmount2: '玩家盈利:',
            betTime: '下注时间',
            createTime: '结算时间',
            selectTime: '请选择时间范围',
            nobetlist:'暂无投注记录！',
            all:'总共：',
        },
        billDetail: {
            toady: '今日',
            yesterday: '昨日',
            finalWeek: '最近7天',
            finalMonth: '最近30天',
            allType: '全部',
            SystemTransfer: '系统调帐',
            RepaidDeposit: '充值存款',
            withdrawals: '秒速提款',
            SwitchToGame: '转入游戏',
            GameOut: '游戏转出',
            discounts: '优惠红利',
            ManualDeposit: '人工存入',
            ManualRemoval: '人工取出',
            Betting:'投注',
            Payout:'派彩',
            applying:'申请中',
            transNo: '订单号',
            orderName: '订单名称',
            orderTime: '时间',
            payType: '交易类型',
            amount: '金额',
            status: '状态'
        },
        myDiscountin: {
            title: '我的优惠',
            allType: '全部类型',
            applying: '申请中',
            successfulCollection: '成功领取',
            finishFlow: '完成流水',
            cancel: '拒绝',
            Clearance: '清除稽核',
            Unclaimed: '未领取',
            noPrize: '未抽中',
            noOffer: '尚无优惠',
            clickApply: '点击申请',
            discountItem: {
                needLaveBetflow: '需{laveBetflow}泰铢娱乐场流水可领取',
                needLaveBetflow2: ' 需{laveBetflow}泰铢娱乐场流水可提现',
                flowDone: ' 流水已达成',
                loseEfficacy: '失效'
            }
        },
        safein: {
            realName:'真实姓名',
            email:'电子邮箱',
            phone:'手机',
            bankcard:'银行卡',
            emailTitle: '邮箱认证',
            emailSubTitle: '用于重置密码或身份验证',
            nameTitle: '实名认证',
            nameSubTitle: '确认身份信息',
            phoneTitle: '绑定您的手机号码',
            vipTitle: '登录密码',
            codeTitle: '取款密码',
            revisecodeTitle: '修改取款密码',
            codeSubTitle: '保护您的账户！',
            bankTitle: '已绑定银行卡{length}张',
            management:'管理',
            revise: '修改',
            authen: '去认证',
            set: '去设置',
            receive: '领取优惠',
            start: '启用',
            customer: '修改请联系客服',
            sendcode:'发送验证码',
            alterAction:'修改{str}需要联系客服,是否继续？',
            confirmText: '确定',
            cancelText: '取消',
            common1:'请先完成手机认证',
            common2:'代理邀请红利发放成功！详情请查看我的优惠。',
            common3:'未知系统异常',
            Resend:'后重新发送',
            Congratulations:'恭喜',
        },
        verifyEmail:{
            title:'绑定您的邮箱',
            subTitle1:'请输入邮箱地址',
            subTitle2:'请输入验证码',
            sendcode:'发送验证码',
            suffix: '秒后再次发送',
            cancel:'取 消',
            confrim: '认 证',
            tips:'1.我们已经向您的邮箱发送一份包含验证码的邮件。若没有收到，请点击发送验证码按钮。',
            tips2:'2.系统发送的邮件可能被邮件运营商误判为垃圾邮件，您可以在收件箱和垃圾邮件箱中查找。',
            emailHadSend:'邮件已发送，请注意查收',
            emailConfrim:'邮箱认证',
        },
        verifyName:{
            title:'实名认证确认身份信息',
            subTitle1:'请输入您的真实姓名',
            subTitle2:'请输入您的身份证号',
            cancel:'取 消',
            confrim: '认 证',
            tips:'为保障你的账户安全及合法权益，请确认账户身份是你本人。',
            nameConfrim:'实名认证',
        },
        verifyPhone:{
            title:'绑定您的手机',
            subTitle1:'请输入手机号码',
            subTitle2:'请输入验证码',
            sendcode:'发送验证码',
            suffix: '秒后再次发送',
            cancel:'取 消',
            confrim: '认 证',
            modify:"修改",
            modifyph:"修改手机号",
            tips:'如果您忘记了登录信息，这些信息将被用来恢复您的帐户！',
            mileHadSend:'短信已发送，请注意查收',
            phoneConfrim:'手机认证',
        },
        loginPassword:{
            title:'修改登录密码',
            subTitle1:'请输入旧登录密码',
            subTitle2:'新登录密码',
            subTitle3:'确认新密码',
            cancel:'取 消',
            confrim: '修 改',
            tips:'备注：请妥善保管好您的密码，如遗忘请使用密保功能找回，或联系在线客服处理',
            pleaseLogin:'请重新登录',
            oldpwdError:'原密码格式错误',
            pwdError: '新密码格式错误',
            pswIsChange:'登陆密码修改'
        },
        setPassword:{
            title:'设置提款密码',
            subTitle1:'已认证的手机号',
            phoneFirst: '请先认证手机',
            subTitle2:'请输入验证码',
            subTitle3:'请输入支付密码',
            subTitle4:'确认新密码',
            sendcode:'发送验证码',
            suffix: '秒后再次发送',
            cancel:'取 消',
            confrim: '设 置',
            tips:'备注：请妥善保管好您的密码，如遗忘请联系在线客服处理',
            mileHadSend:'短信已发送，请注意查收',
        },
        changePassword:{
            title:'修改提款密码',
            subTitle1:'已认证的手机号',
            phoneFirst: '请输入支付密码',
            subTitle2:'请输入验证码',
            subTitle3:'请输入旧支付密码',
            subTitle4:'请输入新支付密码',
            subTitle5:'确认新密码',
            sendcode:'发送验证码',
            suffix: '秒后再次发送',
            cancel:'取 消',
            confrim: '修 改',
            tips:'备注：请妥善保管好您的密码，如遗忘请联系在线客服处理',
            mileHadSend:'短信已发送，请注意查收',
        },
        email:{
            title:'站内信',
            mineMsg: '我的消息',
            newMsg: '最新消息',
            hasRead: '已读消息',
            noMsg: '暂无消息' ,
            del:'删除',
            sendMsg:'发送新消息',
            msgType:'消息类型：',
            please:'请选择',
            pleaseCheck:'请选择问题类型',
            mine:'主题：',
            minePlease: '请输入主题',
            content: '内容：',
            contentPlaese:'请输入内容',
            send:'发送',
            question1:'存取款问题',
            question2:'优惠活动',
            question3:'游戏问题',
            question4:'其它问题',
            question5:'建议',
            question6:'投诉',
            checkInfo:'请选择删除信息',
            delSuccess:'删除成功',
            submitSuccess:'提交成功',
            finishContent:'请完成内容填写'
        }

    },
    game:{
        playNow:'立即游戏',
        comingSoon:'敬请期待',
        realMoney: '真钱',
        try: '试玩',
        noData:'暂无相关游戏'
    },
    slot:{
        gameSearch:'游戏搜索',
        reset:'重置选择',
        mineCollect: '我的收藏',
        mineCollect2: '暂无收藏！',
        gameLobby: '游戏大厅:',
        gameTypes:'游戏类型',
        hotGame:'热门游戏',
        newGame:'最新游戏',
        recommend: '推荐游戏',
        all:'全部',
        PrizePoolGame:'奖池游戏',
        classicGame:'经典游戏',
        xxl:'消消乐',
        electricHorn: '电动角子',
        line:'线',
        pleaseEnter:'请输入搜索内容',
        add:'添加收藏',
        addSuucess:'添加收藏成功',
        cancelSuccess:'取消收藏成功',
        hadCollect:'已收藏',
        late:'请稍后再试',
        noLogin:'登陆后即可收藏游戏！',
        hotGameRank:'热门投注游戏排行',
        loading: '拼命加载中',
        gogame: '进入游戏',
        describe:'请登陆后查看!',
        title1:'最近浏览',
        title2:'猜你喜欢',
    },
    footer:{
        webSlogan:'webSlogan',
        MENU:'MENU',
        INFORMATION:'INFORMATION',
        LINKS:'LINKS',
        Game:'GAME PROVIDERS'
    },
    form: {
        //
        checkMoney1: '请输入金额',
        checkMoney2: '金额格式错误',
        checkMoney3: '金额不能为0',
        //
        checkWithdraw: '请输入密码',
        //
        checkRealname: '请输入真实姓名',
        /**校验银行卡*/
        checkBankNumber1: '请输入银行卡号',
        checkBankNumber2: '银行卡号格式错误',
        /** 校验支行*/
        checkBranch: '请输入开户支行',
        /** 校验邮箱 */
        checkEmail1: '请输入邮箱',
        checkEmail2: '邮箱格式错误',
        /** 校验身份证 */
        checkCard1: '请输入身份证号',
        checkCard2: '身份证格式错误',
        /**校验手机号*/
        checkPhone1: '请输入手机号',
        checkPhone2: '请输入正确的手机号',
        /** 校验密码 */
        checkPassword: '请输入密码',
        /** 校验确认密码 */
        checkConfirm1: '请再次输入密码',
        checkConfirm2: '两次密码输入不一致',
        /** 校验原密码确认密码 */
        checkConfirms: '新密码与原密码相同',
        /**校验验证码*/
        checkVerifiCode1: '验证码不能为空',
        checkVerifiCode2: '验证码格式错误',
        /** 校验账号 */
        checkUsername1: '请输入账号',
        checkUsername2: '6–12位字母、数字或组合',
        /**验证多国数字*/
        checkPhoneNumber1: '请输入正确的手机号',
        checkPhoneNumber2: '请输入手机号',
        /** 校验注册密码 */ 
        checkRegisterPassword1: '请输入密码',
        checkRegisterPassword2: '6–12位字母、数字或组合',
        /** 校验真实姓名 */ 
        checkrealName1:'真实姓名不能为空',
        checkrealName2:'真实姓名不能少于2字符',
        /** 校验qq */ 
        checkQQ1:'qq不能为空',
        checkQQ2:'qq不能少于6字符',
        /** 校验微信 */ 
        checkwechat1:'微信不能为空',
        checkwechat2:'微信不能少于10字符',
        /** 校验邮箱 */ 
        checkemail1:'邮箱不能为空',
        checkemail2:'微信不能少于13位字符或多余20位字符',
        checkemail3:'请输入正确的邮箱格式',
        /** 校验提款密码 */ 
        checkwithdrawPassword1:'提款密码不能为空',
        checkwithdrawPassword2:'提款密码不能少于6位',
        checkBankName:'银行卡还未验证,请稍后再试',
        
        /** 校验提款密码 */ 
        checkNumber1:'请输入金额',
        checkNumber2:'金额格式错误，请输入正整数',
        checkNumber3:'金额不能为0',
        /** 支付金额 **/
        checkPayMoney1:'请输入金额',
        checkPayMoney2:'金额格式错误',
        checkPayMoney3:'存款限额：{min} - {max} INR',
    },
    common: {
        loading: '拼命加载中',
        loading2: '榜单更新中',
        search: '搜索',
        tips: '温馨提示',
        congratulations: '恭喜您！',
        success: '成功',
        confirmButtonText: '确定',
        confirmButtonText2: '知道了',
        cancelButtonText:'取消',
        money: '泰铢',
        needLogin: '登录后才能进行游戏',
        tryTitle:'试玩没有任何奖励, 是否继续?',
        tryTitle2:'该游戏不能试玩, 去登录?',
        loginOut: '退出登录',
        close:'关闭',

    },
    timer: {
        finalWeek: '最近一周',
        finalMonth: '最近一个月',
        finalThreeMonth: '最近三个月'

    },
    state: {
        discountsTypes: {
            all: '全部类型',
            rebateBonus: '返水红利',
            depositDiscount: '存款优惠',
            RescueFund: '救援金',
            UpgradeAward: 'VIP升级奖励',
            WinningAwards: 'VIP蝉联奖励',
            OtherPreferences: '其他优惠',
            RegistrationPreferences: '注册优惠'
        },
        sports_gameTypes: {
            allGame: '所有游戏',
            slots: '电子游戏',
            live: '真人视讯',
            sport: '体育投注',
            lottery: '彩票游戏',
            fish: '捕鱼王',
            chess: '棋牌游戏',
            other: '其他'
        }
    },
    filter: {
        changeName: {
            allType: '全部类型',
            applying: '申请中',
            successfulCollection: '成功领取',
            finishFlow: '完成流水',
            cancel: '拒绝',
            Clearance: '清除稽核',
            Unclaimed: '未领取',
            noPrize: '未抽中',
        },
        bonusTypes: {
            Predividend: '前置红利',
            Postdividend: '后置红利',
            Deductdividends: '减去红利'
        },
        bonusName: {
            rebateBonus: '返水红利',
            depositDiscount: '存款优惠',
            Invitation: '邀请奖励',
            signin: "签到奖励",
            ContinuousDeposit: '连续存款优惠',
            register: '注册优惠',
            RescueFund: '救援金',
            UpgradeAward: 'VIP升级奖励',
            WinningAwards: 'VIP蝉联奖励',
            OtherPreferences: '其他优惠',
        },
        bonusLockPlatform:{
            mineAccount: '主账户'
        },
        bonusLockStatus:{
            status1: '锁定中',
            status2: '已解锁',
            status4: '已取消',
        },
        depositLockStatus:{
            status1: '锁定中',
            status2: '已解锁',
            status3: '锁定中'
        },
        gameName:{
            name1: '老虎机',
            name2: '真人',
            name3: '体育',
            name4: '彩票',
            name5: '捕鱼王',
            name6: '棋牌',
            name7: '3D厅',
        },
        changeTitle:{
            name0:'申请中',
            name1:'系统调帐',
            name2:'充值存款',
            name3:'秒速取款',
            name4:'转入游戏',
            name5:'游戏转出',
            name8:'优惠红利',
            name9:'人工存入',
            name10:'人工取出',
            name11:'投注',
            name12:'派彩',
            name13:'申请中',
        },
        withdrawalStatus:{
            withdrawalStatus0:'申请中',
            withdrawalStatus1:'出款中',
            withdrawalStatus2:'成功',
            withdrawalStatus3:'拒绝',
            withdrawalStatus4:'出款中',
            withdrawalStatus5:'出款中',
        }
    },
    catchFish:{
        in:'在',
        income:'倍收益',
        Deepsealive:'深海实况',
        Deepsealive2:'实况更新中',
        time:'分钟前',
        time2:'中捕获',
        time3:'一条',
        fishKing:'上周捕鱼王',
        fishKing2:'每周二更新',
    },
    invitation:{
        title:'邀请好友',
        title2:'邀请好友链接',
        title3:'我的好友',
        copy:'复制链接',
        registereduser:'注册用户',
        time:'时间',
        InviteeStatus:'被邀请人状态',
        BonusStatus:'红利状态',
        Received:'已领取',
        receive:'领取',
        expired:'已过期',
        ActivityRules:'活动规则：',
        ActivityRules2:'邀请人需要先领取红利，被邀请人才可以获取到红利。',
        CopySuccessful:'复制成功',
        SuccessfullyReceived:'领取成功',
    },
    jackpot:{
        Listofwinners:'获奖名单',
        accountNumber:'用户',
        game:'游戏',
        bonus:'奖金',
    },
    marquree:{
        Notice:'公告',
        Close:'关闭',
    },
    betting: {
        title: '投注',
        needLogin: '您还未登录哟！',
        AvailableBalance: '可用余额',
        betSuccess: '投注成功！',
        recharge: '充值',
        inLottery: '开奖中',
        rule: '查看规则',
        issues: '期号',
        rules: '投注规则',
        betSubmit: '投注',
        addcart: '加入购物车',
        clear: '清除',
        add: '+',
        totalTxt: '总计',
        noselected: '请选择投注号码！',
        noEnoughMoney: '你已选择投注金额大于可用余额！',
        Count:'注数',
        Amount:'金额',
        betNow:'立即投注',
        Total:'总计',
        TotalCount:'总注数',
        TotalAmount:'总金额',
        TotalWinLost:'总输赢',
        date:'开奖日期',
        settleType: {
          all: '全部',
          noSettle: '未结算',
          settle: '结算',
          win: '赢',
          lose: '输'
        },
        trafficList: {
          0: 'Number',
          10: 'Red',
          12: 'Blue',
          11: 'Yellow',
        },
        cartHead: {
          type: '类型',
          details: '投注详情',
          multiple: '倍数',
          money: '金额'
        },
        lotteryTab: {},
        countDown: '距下一期',
        record: {
          title1: '开奖记录',
          title2: '我的投注记录',
          title: '投注记录',
          orderNo: '订单号',
          betMoney: '投注金额',
          dealMoney: '交易金额',
          serviceAmount: '手续费',
          drawNum: '开奖号码',
          betNum: '投注号码',
          status: '状态',
          rewards: '回报',
          betTime: '投注时间',
          tableHead: {
            Period: '期号',
            Price: '奖池',
            Numbers: '开奖号码',
            Result: '中奖区域'
          },
        }
    },
    ghistory: {
		title: 'Bet Detail',
		Playerid: 'Player ID',
		gameid: 'Game ID',
		insurance: 'insurance',
		WinorLoss: 'Total win/loss',
		betTime: 'Bet time:',
		orderNo: 'Txn. ID',
		Status: 'Status',
		Provider: 'Provider',
		Event: 'Event',
		betArea: 'Bet area',
        gameName: 'Game name',
		total: "Total",
		Odds: 'Odds',
		TotalBets: 'Total Bets',
		ValidBets: 'Valid Bets',
		WinorLoss2: 'Win/Loss',
		close: 'close',
		Running: 'Running',
        Settled: 'Settled',
        Game: 'Game',
	},
    ...zhLocale
}

export default zh_CN


// WEBPACK FOOTER //
// ./src/pages/build901/i18n/langs/zh_CN.js